/**
 * 공유 인증 유틸리티
 * 환경변수 기반 토큰 저장소를 사용합니다
 */
import { tokenStorage } from "./token-storage";

// 토큰 저장/조회 함수들
export const writeAccessToken = (accessToken: string) => {
  tokenStorage.setAccessToken(accessToken);
};

export const writeRefreshToken = (refreshToken: string) => {
  tokenStorage.setRefreshToken(refreshToken);
};

export const readAccessToken = () => {
  return tokenStorage.getAccessToken();
};

export const readRefreshToken = () => {
  return tokenStorage.getRefreshToken();
};

export const logout = () => {
  tokenStorage.clear();
  window.location.href = "/login";
};

export const validateToken = async () => {
  // TODO: 토큰 유효성 검증 구현
};
